import React from "react";
import Modal from "material-ui/Modal";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import Radio, { RadioGroup } from "material-ui/Radio";

import { FormControl, FormControlLabel, FormLabel } from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "../new/styles";

import { DraggableModalFrame, ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

class TestSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      fiber: false,
      copper: false,
      wifi: false,
      next: true,
      jobType: this.props.jobType,
      coax: false,
      cable: true,
      network: false,
      showSubTestType: false,
    };
  }

  onChange = e => {
    let currentSelection = e.target.value;
    switch (currentSelection) {
      case "fiber":
        this.setState({
          fiber: true,
          copper: false,
          wifi: false,
          coax: false,
          next: false,
          showSubTestType: true
        });
        break;
      case "copper":
        this.setState({
          fiber: false,
          copper: true,
          wifi: false,
          coax: false,
          next: false,
          showSubTestType: true
        });
        break;
      case "wifi":
        this.setState({
          fiber: false,
          copper: false,
          wifi: true,
          coax: false,
          next: false,
          showSubTestType: false
        });
        break;
      case "coax":
        this.setState({
          fiber: false,
          copper: false,
          wifi: false,
          coax: true,
          next: false,
          showSubTestType: false
        });
        break;
      case "cable":
        this.setState({
          cable: true,
          network: false,
          next: false
        });
        break;
      case "network":
        this.setState({
          cable: false,
          network: true,
          next: false
        });
        break;
      default:
        this.setState({
          cable: false,
          network: false,
          next: false
        });
    }
  };

  handleClose = () => {
    this.setState({
      open: false
    });
    this.props.cancel("cancel", "testSelection");
  };

  selectedTest = () => {
    const { testSelection } = this.props;
    const { fiber, copper, wifi, coax, cable, network } = this.state;
    testSelection(fiber, copper, coax, wifi, cable, network);
  };

  render() {
    const { classes, translate } = this.props;

    const { fiber, copper, coax, wifi, next, jobType, cable, network, showSubTestType } = this.state;

    return (
      <Modal open={this.state.open} onClose={this.handleClose}>
        <div className={classes.root}>
          <DraggableModalFrame
            paperClassName={classes.modal}
            header={
              <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_add")}
              </Typography>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
              </ModalHeader>
            }
          >
            <ModalContents>
              <div 
                style = {{
                  display: "flex",
                  gap: "200px",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <FormLabel component="legend">
                    {jobType == "Signaltek"
                      ? translate("test_types_signaltek")
                      : translate("test_types")}
                  </FormLabel>
                  <RadioGroup
                    aria-label="testSelection"
                    name="testSelection"
                    className={classes.group}
                    onChange={this.onChange}
                  >
                    <FormControlLabel
                      value="fiber"
                      control={<Radio checked={fiber} />}
                      label={
                        jobType == "Signaltek" || jobType == "Navitek"
                          ? translate("create_signaltek_fiber")
                          : translate("create_comet_fiber")
                      }
                    />
                    <FormControlLabel
                      value="copper"
                      control={<Radio checked={copper} />}
                      label={
                        jobType == "Signaltek" || jobType == "Navitek"
                          ? translate("create_signaltek_copper")
                          : translate("comet_copper")
                      }
                    />
                    {jobType != "Signaltek" && jobType != "Navitek" && (
                      <FormControlLabel
                        value="coax"
                        control={<Radio checked={coax} />}
                        label={translate("create_comet_coax")}
                      />
                    )}
                    {jobType == "Navitek" && (
                      <FormControlLabel
                        value="wifi"
                        control={<Radio checked={wifi} />}
                        label={translate("WiFi")}
                      />
                    )}
                  </RadioGroup>
                </div>
                <div>
                  {showSubTestType && jobType == "Navitek" && (
                    <div>
                      <FormLabel component="legend">
                        {translate("subtest_type")}
                      </FormLabel>   
                      <RadioGroup
                      aria-label="subTestSelection"
                      name="subtestSelection"
                      className={classes.group}
                      value={cable ? "cable" : network ? "network" : ""}
                      onChange={this.onChange}
                      >
                        <FormControlLabel
                          value="cable"
                          control={<Radio />}
                          label={
                            translate("cable")
                          }
                        />
                        <FormControlLabel
                          value="network"
                          control={<Radio />}
                          label={
                            translate("network")
                          }
                        />
                      </RadioGroup>
                    </div>
                  )} 
                </div>
              </div>
            </ModalContents>
            <ModalFooter>
              <Button
                raised
                color="accent"
                className={classes.submit}
                onClick={() => this.selectedTest()}
                type="submit"
                disabled={next}
              >
                <Icon>navigate_next</Icon>
              </Button>
            </ModalFooter>
          </DraggableModalFrame>
        </div>
      </Modal>
    );
  }

  renderTranslatedValue = (selectedValue, translate) => {
    return selectedValue && selectedValue.length && translate(selectedValue[0].value);
  };
}

export default withStyles(styles)(TestSelection);
